module.exports = __webpack_public_path__ + "img/yellow_pet_pen.d627eab8.svg";